<template>
    <div>
        <button type="button" class="btn btn-secondary btn-sm float-right ml-2 mb-2" @click="refresh()"><i class="fas fa-sync-alt"></i> Refresh</button>
        <transition name="fade">
            <button v-if="selectedItemStatusInProgress && userHasAccess" type="button" class="btn btn-secondary btn-sm float-right mb-2" @click="$bvModal.show(_uid + 'update-status-modal')"><i class="fas fa-edit"></i> Update status</button>
        </transition>

        <div v-if="loading && loading == true" class="row align-items-center justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

        <table v-else class="table">
            <thead>
                <tr>
                    <th scope="col">Gadget</th>
                    <th scope="col">Token / Trans Id</th>
                    <th scope="col">Status</th>
                    <th scope="col">Currency</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Attempted Date</th>
                    <th scope="col">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(itm, idx) in dataList" :key="'claimexcesspaymentlist_' + idx"
                    :class="selectedRowIndex == idx ? 'table-primary' : ''"
                    :style="'cursor: pointer'"
                    @click="handleRowClick(idx, itm)">
                    <td>{{itm.displayLabel}}</td>
                    <td>{{itm.processorToken}}</td>
                    <td>{{itm.cardPaymentStatusLabel}}</td>
                    <td>{{itm.cardPaymentCurrencyCode}}</td>
                    <td>{{itm.excess}}</td>
                    <td>{{itm.cardPaymentDateAsLocalTime}}</td>
                    <td>
                        <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret :boundary="'window'">
                            <template v-slot:button-content>
                                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                <span class="sr-only">Actions menu</span>
                            </template>
                            <b-dropdown-item href="javascript:void(0)" @click="handleCreateClaimPaymentClick(idx,itm)" :disabled="itm.claimPaymentId > 0 || !claimPaymentsEnabled">
                                <i v-if="false" :class="iconClass"></i> Create Claim Payment
                            </b-dropdown-item>
                        </b-dropdown>
                    </td>
                </tr>
            </tbody>
        </table>


        <b-modal :id="_uid + 'update-status-modal'" hide-footer>
            <template slot="modal-title">
                Update card payment status
            </template>
            <div v-if="showUsageMessage">
                <p>Only use this if: 1. Current status is IN_PROGRESS and there is no transaction for this payment with the Provider, set the status to MANUAL_OVERRIDE, 2. Current status is IN_PROGRESS and there is a transaction for this payment with the Provider that has been authorised, Set the status to AUTHORISED and provide the appropriate token.</p>
                <div class="row">
                    <div class="col">
                        <div class="float-right">
                            <button class="btn btn-danger mt-3" @click="handleCancelClick">Cancel</button>
                            <button class="btn btn-success mt-3 ml-2" @click="() => showUsageMessage = false">OK</button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="d-block text-center">
                    <div v-if="selected && selected.length > 0">
                        <div class="row">
                            <div class="col"><strong>Transaction Id:</strong></div>
                            <div class="col">{{selected[0].invoiceId}}</div>
                        </div>
                        <div class="row">
                            <div class="col"><strong>Job Id:</strong></div>
                            <div class="col">{{selected[0].cardPaymentId}}</div>
                        </div>
                        <div class="row">
                            <div class="col"><strong>Type:</strong></div>
                            <div class="col">{{selected[0].typeLabel}}</div>
                        </div>
                        <div class="row">
                            <div class="col"><strong>Make:</strong></div>
                            <div class="col">{{selected[0].makeLabel}}</div>
                        </div>
                        <div class="row">
                            <div class="col"><strong>Model:</strong></div>
                            <div class="col">{{selected[0].modelLabel}}</div>
                        </div>
                        <div class="row">
                            <div class="col"><strong>IMEI / Serial:</strong></div>
                            <div class="col">{{selected[0].imeiNo}}{{selected[0].serialNo}}</div>
                        </div>
                        <div class="row">
                            <div class="col"><strong>Attempted Date:</strong></div>
                            <div class="col">{{selected[0].cardPaymentDateAsLocalTime}}</div>
                        </div>
                        <div class="row">
                            <div class="col"><strong>Current Status:</strong></div>
                            <div class="col">{{selected[0].cardPaymentStatusLabel}}</div>
                        </div>
                    </div>
                    <hr />
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label">
                            New Status
                        </label>
                        <div class="col-sm-8">
                            <select class="form-control  form-control-sm" v-model="objEx.newStatus">
                                <option :value="null">
                                    -- SELECT --
                                </option>
                                <option :value="1001">
                                    AUTHORISED
                                </option>
                                <option :value="1014">
                                    MANUAL_OVERRIDE
                                </option>
                            </select>
                            <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="attemptSave && !getValidatorIsValid(objEx,'newStatus')">
                                {{getValidatorInvalidFeedback(objEx,'newStatus')}}
                            </div>
                        </div>
                    </div>
                    <transition name="fade">
                        <div v-if="objEx.newStatus == 1001" class="form-group row">
                            <label class="col-sm-4 col-form-label">
                                Token
                            </label>
                            <div class="col-sm-8">
                                <input type="text" class="form-control form-control-sm"
                                       placeholder="Payment provider token"
                                       v-model="objEx.token">
                                <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="attemptSave && !getValidatorIsValid(objEx,'token')">
                                    {{getValidatorInvalidFeedback(objEx,'token')}}
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="float-right">
                            <button class="btn btn-danger mt-3" @click="handleCancelClick">Cancel</button>
                            <button class="btn btn-success mt-3 ml-2" @click="handleSaveClick">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'

    import { required, requiredIf } from '@/util/validators'
    import { runValidators, getValidators, getValidatorsIsValid } from '@/util/validation'

    import watchAll from '@/mixins/watchAll.js'
    import validator from '@/mixins/validator.js'

    import authentication from '@/mixins/authentication.js'
    import userRoles from '@/constants/userRoles.js'

    import DataListPagination from '@/components/DataListPagination.vue'
    import { excessPaymentsCols } from '@/ui.config/cols/excessPaymentsCols'
    import { selectedExcessPaymentInputs } from '@/ui.config/inputs/selectedExcessPaymentInputs'
    import { mapActions, mapGetters } from 'vuex'

    let initObjEx = {
        newStatus: null,
        token: null,
        validators: [
            {
                item: 'newStatus',
                validators: [
                    required
                ],
                isValid: false,
                inValidFeedback: 'Required'
            },
            {
                item: 'token',
                validators: [
                    requiredIf('newStatus', 1001)
                ],
                isValid: false,
                inValidFeedback: 'Required'
            }
        ]
    }
    export default {
        name: 'ClaimExcessPaymentsList',
        props: {
            claimId: {
                type: Number,
                required: true
            },
            load: Boolean
        },
        mixins: [
            watchAll,
            validator,
            authentication
        ],
        components: {
            DataListPagination
        },
        watch: {
            load: async function (newVal, oldVal) {
                if (newVal == true) {
                    await this.getForClaim(this.claimId)
                }
            }
        },
        data: () => {
            return {
                cols: excessPaymentsCols,

                selected: null,
                selectedInputs: selectedExcessPaymentInputs,

                pageNumber: 1,
                pageSize: 10,

                objEx: Object.assign({}, initObjEx),
                attemptSave: false,

                showUsageMessage: true,

                loading: false,
                selectedRowIndex: null,
                //payments: []
            }
        },
        mounted() {
            this.watchAll(['objEx.newStatus', 'objEx.token'], this.objExRunValidators.bind(this));
        },
        computed: {
            ...mapGetters({
                claimPaymentsEnabled: 'appSettings/claimPaymentsEnabled'
            }),
            selectedClaim() {
                return this.$store.getters.selectedClaim
            },
            payments() {
                if (this.selectedClaim && this.selectedClaim.excessPaymentDetails) {
                    return this.selectedClaim.excessPaymentDetails
                }
                return null
            },
            dataList() {
                //console.log("-p : ", this.payments)
                if (this.payments) {
                    return this.payments.map(o => ({ ...o, displayLabel: `${o.makeLabel} - ${o.modelLabel} - ${o.serialNo || o.imeiNo}` }))
                }

                return []
            },
            selectedItemStatusInProgress() {
                if (this.selected != null && this.selected.length > 0) {
                    let { cardPaymentStatusId } = this.selected[0]
                    if (cardPaymentStatusId == 1013) {
                        return true
                    }
                }

                return false
            },
            userHasAccess() {
                return this.userHasRole(userRoles.UPDATE_CARDPAYMENT_STATUS)
            }
        },
        methods: {
            ...mapActions({
                fetchData: 'fetchExcessPaymentsClaim',
                updateStatus: 'updateCardPaymentStatus'
            }),
            handleItemDblClick(payload) {
                this.selected = payload
            },
            handleItemSglClick(payload) {

                this.selected = payload
            },
            handlePaginationInput(payload) {
                if (payload) {
                    this.selected = null
                    this.pageNumber = payload
                    this.search()
                }
            },
            //search() {
            //    let { claimId } = this.selectedClaim
            //    let { pageSize, pageNumber } = this

            //    let ordering = {
            //        orderBy: "CardPaymentDate", sortDirection: "DESC"
            //    }

            //    let pages = {
            //        pageSize,
            //        pageNumber
            //    }

            //    let criteria = {
            //        id: claimId,
            //        ignoreTaskFlag: true,
            //        ...pages,
            //        ...ordering
            //    }

            //    this.fetchData(criteria)
            //},
            handleSaveClick() {
                this.attemptSave = true
                if (getValidatorsIsValid(this.objEx)) {
                    this.$bvModal.hide(this._uid + 'update-status-modal')


                    let { claimId } = this.selectedClaim
                    let { selected, objEx, pageSize, pageNumber } = this

                    let ordering = {
                        orderBy: "CardPaymentDate", sortDirection: "DESC"
                    }

                    let pages = {
                        pageSize,
                        pageNumber
                    }

                    let payload = {
                        id: selected[0].cardPaymentId,
                        claimId: claimId,
                        newStatusId: objEx.newStatus,
                        token: objEx.token,
                        ...pages,
                        ...ordering
                    }

                    this.updateStatus(payload)
                    this.selected = null
                    this.objExReset()
                    this.attemptSave = false
                    this.showUsageMessage = true
                }
            },
            handleCancelClick() {
                this.$bvModal.hide(this._uid + 'update-status-modal')
                this.objExReset()
                this.showUsageMessage = true
            },
            objExRunValidators() { runValidators(this.objEx) },
            objExReset() { this.objEx = Object.assign({}, initObjEx) },
            async getForClaim(claimId) {
                //console.log('PING2')
                if (claimId && !isNaN(claimId)) {
                    //console.log('PING3')
                    this.loading = true

                    let { pageSize, pageNumber } = this

                    let payload = {
                        id: claimId,
                        ignoreTaskFlag: true,
                        pageSize,
                        pageNumber,
                        orderBy: "CardPaymentDate",
                        sortDirection: "DESC"
                    }

                    try {
                        const response = await this.fetchData(payload)
                            //await axios.post('/api/admin/v1/claims/recentcardpayments', payload)
                        //console.log("-r : ", response)
                        const { data } = response
                        //this.payments = data.data
                    } catch (error) {
                        console.error(error)
                    } finally {
                        this.loading = false
                        this.$emit('finished-loading')
                    }
                }
            },
            async refresh() {
                await this.getForClaim(this.claimId)
            },
            async handleCreateClaimPaymentClick(idx, itm) {
                let { cardPaymentId } = itm
                let payload = {
                    sourceEntityId: cardPaymentId,
                    sourceEntityType: 3
                }

                //console.log('-p : ', payload)
                this.loading = true
                try {
                    const response = await axios.post('/api/admin/v1/finance/createclaimpayment/', payload)
                    //console.log("-r : ", response)
                    //const { data } = response
                    //if (data) {

                    //}

                } catch (error) {
                    console.error(error)
                } finally { this.loading = false }
            },
            async handleRowClick(idx, itm) {
                this.selectedRowIndex = idx
            }
        }
    }
</script>

